module.exports = __webpack_public_path__ + "static/media/tb_app_icon_delete.d177c80a.svg";